import styled from 'styled-components';
import { ComboboxLoadingStateMixin } from '../../mixins/components/ComboboxLoadingStateMixin';
export var StyledComboboxLoadingState = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledComboboxLoadingState",
  componentId: "c11n-8-107-0__sc-1yxjp86-0"
})(["", ""], ComboboxLoadingStateMixin);